export default __webpack_public_path__ + "static/media/yellow-email.97269340.png";